export default __webpack_public_path__ + "static/media/Sigil of Funeral Flames.3371729c.jpg";